<template>
    <ion-select
        :value="modelValue"
        @ionChange="$emit('update:modelValue', $event.detail.value)"
        :placeholder="placeholder"
    >
        <ion-select-option value="Customer Return">Customer Return</ion-select-option>
        <ion-select-option value="Returning Office">From Office</ion-select-option>
        <ion-select-option value="Returning Sample">From Sample</ion-select-option>
        <ion-select-option value="Unit">Unit</ion-select-option>
        <ion-select-option value="Correcting Stock" v-if="isAdmin">Correcting Stock</ion-select-option>
        <ion-select-option value="Amazon Overstock">Amazon OverStock</ion-select-option>
    </ion-select>
</template>

<script>
import Storage  from '@/services/Storage';
import { onMounted, ref } from "vue";
import {
    IonSelect, IonSelectOption
} from '@ionic/vue';
export default {
    name: "StockReturnReasonSelect",
    components: {IonSelect, IonSelectOption},
    emits: [
        'update:modelValue'
    ],
    props: {
        modelValue: String,
        placeholder: {
            type: String,
            default: 'Please select'
        }
    },
    data() {
        return {
            isAdmin: false
        }
    },
    mounted() {
        const storage = new Storage();
        storage.get('user').then(user => {
            this.isAdmin = user.roles.warehouse_mgr || user.roles.super;
            console.log(this.isAdmin);
        });
    }
}
</script>

<style scoped>

</style>
